<template>
  <div
    class="total-cost position-relative d-flex flex-column justify-content-center align-items-center"
  >
    <div class="total-cost_icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="70"
        viewBox="0 0 36 70"
        fill="none"
      >
        <path
          d="M17.5969 70C16.506 70 15.5923 69.6266 14.8556 68.88C14.119 68.1333 13.7493 67.2104 13.7468 66.1111V61.6389C10.8592 60.9907 8.32451 59.8565 6.14277 58.2361C3.96103 56.6157 2.19639 54.3472 0.848847 51.4305C0.399665 50.5231 0.384264 49.5678 0.802645 48.5644C1.22103 47.5611 1.97437 46.8313 3.06267 46.375C3.96103 45.9861 4.89148 46.003 5.85401 46.4255C6.81655 46.8481 7.55449 47.5443 8.06784 48.5139C9.15871 50.4583 10.5383 51.9335 12.2067 52.9394C13.8751 53.9454 15.9285 54.447 18.3669 54.4444C20.9979 54.4444 23.2271 53.8455 25.0546 52.6478C26.8821 51.45 27.7972 49.5859 27.7997 47.0555C27.7997 44.787 27.0939 42.9891 25.6822 41.6617C24.2705 40.3343 20.9978 38.8267 15.8643 37.1389C10.3458 35.3889 6.55987 33.2993 4.50647 30.87C2.45307 28.4407 1.42636 25.4748 1.42636 21.9722C1.42636 17.7593 2.77391 14.4861 5.469 12.1528C8.16409 9.81945 10.9233 8.49075 13.7468 8.16668V3.8889C13.7468 2.78705 14.1164 1.86279 14.8556 1.11612C15.5948 0.369457 16.5086 -0.00257914 17.5969 1.34564e-05C18.6852 0.00260605 19.6003 0.37594 20.342 1.12001C21.0838 1.86409 21.4522 2.78705 21.447 3.8889V8.16668C23.8854 8.55556 26.003 9.35019 27.7997 10.5506C29.5965 11.7509 31.0724 13.2248 32.2274 14.9722C32.8049 15.8148 32.9178 16.7546 32.5662 17.7917C32.2146 18.8287 31.492 19.5741 30.3986 20.0278C29.5002 20.4167 28.5698 20.4335 27.6072 20.0783C26.6447 19.7232 25.7463 19.0906 24.9121 18.1806C24.078 17.2706 23.0987 16.5744 21.9745 16.0922C20.8503 15.61 19.4552 15.3663 17.7894 15.3611C14.966 15.3611 12.8163 15.9937 11.3404 17.2589C9.86456 18.5241 9.12662 20.0952 9.12662 21.9722C9.12662 24.1111 10.0892 25.7963 12.0142 27.0278C13.9393 28.2593 17.2761 29.5556 22.0246 30.9167C26.4522 32.213 29.8057 34.2715 32.0849 37.0922C34.3642 39.913 35.5026 43.1693 35.5 46.8611C35.5 51.463 34.1525 54.963 31.4574 57.3611C28.7623 59.7592 25.4255 61.25 21.447 61.8333V66.1111C21.447 67.213 21.0774 68.1372 20.3382 68.8839C19.599 69.6305 18.6852 70.0026 17.5969 70Z"
          fill="#218863"
        />
      </svg>
    </div>
    <h1 class="total-cost_value">RM {{ total }}</h1>
    <p class="total-cost_label">Total Cost</p>
    <div
      class="info"
      data-bs-toggle="tooltip"
      data-bs-placement="right"
      title="The value calculated based on schedule for this month"
    >
      i
    </div>
  </div>
</template>

<script>
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";
export default {
  props: ["items"],
  computed: {
    total() {
      return this.items || 0;
    },
  },
  mounted() {
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  },
  unmounted() {
    let popovers = document.getElementsByClassName("tooltip");
    popovers.forEach((item) => {
      item.remove();
    });
  },
};
</script>

<style lang="scss" scoped>
.total-cost {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: linear-gradient(142deg, #bcefdb 41.95%, #a0cce7 96.79%);
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);
  &_icon {
    width: 142px;
    height: 142px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: 100px;
    margin-bottom: 30px;
    background: radial-gradient(50% 50% at 50% 50%, #e2fef2 0%, #8bd9ba 100%);
    box-shadow: 4px 4px 8px 0px rgba(226, 254, 242, 0.2);
  }
  &_value {
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
  }
  &_label {
    color: #218863;
    font-family: Poppins;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
  }
}
</style>